import {PALETTE_IDS} from '#core/application/modules/ids.js';

const COLOR = {
    SCRIM_LIGHT: 'rgba(0, 0, 0, 0.6)',
    SCRIM_DARK: 'rgba(0, 0, 0, 0.8)',
    SHADOW_SHORT: 'rgba(0, 0, 0, 0.3)',
    SHADOW_LONG: 'rgba(0, 0, 0, 0.5)',

    // Colors from brandbook
    BRAND_BLACK1: '#090017',
    BRAND_BLACK2: '#1f1331',
    BRAND_GREEN: '#65bf7d',
    BRAND_YELLOW: '#f0a12b',
    BRAND_WHITE: '#ffffff',

    // Custom colors
    BRAND_GREY: '#e5e5e5',
    BORDER_GREY1: '#27282B',
    BORDER_GREY2: '#4B4B4B',
    DIVIDER: '#090017',
    TRANSPARENT: 'transparent',
};

const FONT = {
    FAMILY: 'greycliff, sans-serif',

    WEIGHT_NORMAL: 400,
    WEIGHT_SEMI_BOLD: 500,
    WEIGHT_BOLD: 600,

    SIZE_XXSMALL: 12,
    SIZE_XSMALL: 12,
    SIZE_SMALL: 13,
    SIZE_MEDIUM: 14,
    SIZE_LARGE: 16,
    SIZE_XLARGE: 18,
};

const TILE_FONT = Object.assign({}, FONT);

export const THEME = {
    [PALETTE_IDS.BASIC]: {
        FONT_FAMILY: 'greycliff, sans-serif',

        FILL_PAGE: COLOR.BRAND_GREY,
        FILL_HEADER: COLOR.BRAND_BLACK1,
        FILL_HERO: COLOR.BRAND_BLACK1,
        FILL_SHEET: COLOR.BRAND_BLACK2,
        FILL_POPOVER: COLOR.BRAND_BLACK1,

        DEFAULT_CONTAINER_BG: COLOR.BRAND_BLACK1,
        FILL_CONTENT_PROMINENT: COLOR.BRAND_BLACK1,

        FILL_CARD: COLOR.BRAND_BLACK1,
        FILL_CARD_PROMINENT: COLOR.BRAND_BLACK1,

        FILL_CONTROL_OUTLINE: COLOR.BRAND_GREY,
        FILL_CONTROL_ACCENT: COLOR.BRAND_BLACK1,
        FILL_CONTROL_ODDS: COLOR.BRAND_GREY,

        FILL_ACCENT_PRIMARY: COLOR.BRAND_GREEN,
        FILL_ACCENT_SECONDARY: COLOR.BRAND_YELLOW,
        FILL_ACCENT_FOCUS: COLOR.BRAND_BLACK1,

        FILL_SELECTED_PRIMARY: COLOR.BRAND_BLACK1,
        FILL_SELECTED_ODDS: COLOR.BRAND_GREEN,

        DEFAULT_PRIMARY_TEXT: `${COLOR.BRAND_WHITE}|${COLOR.BRAND_BLACK1}`,
        DEFAULT_SECONDARY_TEXT: `${COLOR.BRAND_WHITE}|${COLOR.BRAND_BLACK1}`,

        TEXT_ACCENT_PRIMARY: COLOR.BRAND_BLACK1,
        TEXT_ACCENT_SECONDARY: COLOR.BRAND_BLACK1,
        TEXT_ACCENT_FILL: COLOR.BRAND_GREEN,

        DEFAULT_GENERIC_ACCENT_COLOR: COLOR.BRAND_YELLOW,
        DEFAULT_DIVIDER: `${COLOR.BRAND_WHITE}|${COLOR.DIVIDER}`,
    },
    [PALETTE_IDS.FONT]: TILE_FONT,
    [PALETTE_IDS.INFO_NOTIFICATION]: {
        INFO_TEXT: COLOR.BRAND_BLACK1,
    },
    [PALETTE_IDS.ODDS_BUTTON]: {
        ODDS_BORDER_COLOR: COLOR.BORDER_GREY2,
        ODDS_INFO_TEXT: COLOR.BRAND_BLACK1,
        ODDS_SELECTED_INFO_TEXT: COLOR.BRAND_BLACK1,
        ODDS_PRICE_TEXT: COLOR.BRAND_BLACK1,
        ODDS_SELECTED_PRICE_TEXT: COLOR.BRAND_BLACK1,
    },
    [PALETTE_IDS.EVENT_CARDS]: {
        CARD_BORDER_COLOR: COLOR.BORDER_GREY2,
        CARD_CONTAINER_BG: COLOR.BRAND_BLACK2,
        CARD_GAMELINE_MARKET_HEADER_TEXT: COLOR.BRAND_WHITE,
    },
    [PALETTE_IDS.EVENT_LIST]: {
        EVENT_LIST_BG: COLOR.BRAND_BLACK2,
    },
    [PALETTE_IDS.POPOVER]: {
        POPOVER_BORDER_COLOR: COLOR.BORDER_GREY1,
    },
    [PALETTE_IDS.SWITCH]: {
        SWITCH_BUTTON_BG: `${COLOR.BRAND_WHITE}|${COLOR.BRAND_BLACK1}`,
    },
    [PALETTE_IDS.APPLICATION_HEADER]: {
        APPLICATION_HEADER_NAV_BAR_SETTINGS: {
            HEADER_SETTINGS_POPOVER_BORDER_COLOR: COLOR.BORDER_GREY1,
        },
    },
    [PALETTE_IDS.BAD_ROUTE_PAGE]: {
        BAD_ROUTE_PAGE_BG: COLOR.BRAND_BLACK1,
        BAD_ROUTE_PAGE_TITLE_TEXT: {
            color: COLOR.BRAND_GREEN,
            _desktop_fontSize: '300px',
            fontWeight: FONT.WEIGHT_NORMAL,
            fontFamily: FONT.FAMILY_SECOND,
        },
        BAD_ROUTE_PAGE_INFO_TEXT: {
            fontSize: '33px',
            _desktop_marginTop: '-20px',
        },
    },
    [PALETTE_IDS.SEARCH]: {
        SEARCH_INPUT: {
            INPUT_TEXT: {
                color: COLOR.BRAND_WHITE,
            },
        },
    },
    [PALETTE_IDS.RACE_MEETINGS]: {
        RACE_MEETING_BEST_ODDS_GUARANTEED_INDICATOR: {
            BEST_ODDS_GUARANTEED_INDICATOR_LABEL_TEXT: COLOR.BRAND_WHITE,
            BEST_ODDS_GUARANTEED_POPOVER_BORDER_COLOR: COLOR.BORDER_GREY2,
        },
    },
    [PALETTE_IDS.RACE_CARD]: {
        RACE_CARD_BEST_ODDS_GUARANTEED_INDICATOR: {
            BEST_ODDS_GUARANTEED_INDICATOR_LABEL_TEXT: COLOR.BRAND_WHITE,
            BEST_ODDS_GUARANTEED_POPOVER_BORDER_COLOR: COLOR.BORDER_GREY2,
        },
    },
    [PALETTE_IDS.BONUSES]: {
        BONUSES_SECTION_TITLE_TEXT: COLOR.BRAND_WHITE,
    },
    [PALETTE_IDS.ODDS_BOOST_BANNER]: {
        ODDS_BOOSTS_COMMON_COLOR: COLOR.BRAND_WHITE,
        ODDS_BOOSTS_CONTAINER_BG: COLOR.BRAND_BLACK2,
    },
    [PALETTE_IDS.PROMOTION_QUICK_LINKS]: {
        PROMOTION_QUICK_LINK: {
            PRIMARY_LINK_BG: COLOR.BRAND_BLACK2,
        },
    },
};
